export default "__VITE_ASSET__BAsGJBHk__"